import React from 'react';
import { Box, Typography, Divider } from 'src/components';

export default function FeatureList({ features }) {
    return features.map((feature, idx) => (
        <React.Fragment key={idx}>
            <Box sx={{ py: 1.5 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 0.5 }}>
                    {feature.title}
                </Typography>
                
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {feature.description}
                </Typography>
            </Box>
            {idx < features.length - 1 && <Divider />}
        </React.Fragment>
    ));
}
